import { Injectable } from '@angular/core';

import { OverAskOfferResponse } from '@bpos/v1/over-ask';
import { ApiService } from '@frontend/sports/common/api-utils';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { EMPTY, Observable, catchError, of } from 'rxjs';

@Injectable()
export class OverAskApiService {
    private readonly logger: SportsRemoteLogger;

    constructor(
        private api: ApiService,
        loggerFactory: LoggerFactory,
    ) {
        this.logger = loggerFactory.getLogger('OveraskApiService');
    }

    getStatus(offerId: string): Observable<OverAskOfferResponse | undefined> {
        return this.api.get<OverAskOfferResponse>('overask/getstatus', { offerId }).pipe(
            catchError((err) => {
                this.logger.error(err, 'OverAsk getStatus failed.');

                return of(undefined);
            }),
        );
    }

    declineOffer(offerId: string): Observable<void> {
        return this.api.post<void>('overask/declineOffer', { offerId }).pipe(
            catchError((err) => {
                this.logger.error(err, 'OverAsk declineOffer failed.');

                return EMPTY;
            }),
        );
    }
}
